export default __webpack_public_path__ + "static/media/post.2cfda2b2.svg";